// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mb-40[data-v-1c9c765a] {\n    margin-bottom: 40px;\n}\n\n", ""]);
// Exports
module.exports = exports;
